import { useTranslation } from "react-i18next";
import { useCan } from "../../auth/AuthProvider";
import { BackupPanel } from "../../components/BackupPanel";
import { Card, CardHeader } from "../../components/ui";
import { useDatabaseTabContext } from "./context";

export function DatabaseBackupsTab() {
  const { orgId, database } = useDatabaseTabContext();
  const canManage = useCan("developer");
  const canRestore = useCan("admin");
  const { t } = useTranslation("database");

  return (
    <Card>
      {/* Title only: the switch row inside the panel carries the description,
          and the same sentence twice an inch apart read as a stutter. */}
      <CardHeader title={t("backups.tabTitle")} />
      <div className="p-5">
        <BackupPanel orgId={orgId} database={database} canManage={canManage} canRestore={canRestore} />
      </div>
    </Card>
  );
}
